import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="65158" id="ready-to-book" className="relative w-full py-24 md:py-32 overflow-hidden bg-primary text-white">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596668/img/pattern_overlay.png)] opacity-20 mix-blend-overlay pointer-events-none" />
      <div className="absolute top-0 left-0 w-full h-full bg-black/10 pointer-events-none" />

      <div ref={ref} className={`relative z-10 container mx-auto px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-medium tracking-tight mb-6 drop-shadow-md">
          Ready for your SoCal getaway?
        </h2>
        
        <p className="font-sans text-lg md:text-xl text-white/90 max-w-2xl mb-6 font-light tracking-wide">
          Experience comfort and convenience in Westminster, CA near Disney and Knotts. Rooms start at just $50 on weekdays and $55 on weekends.
        </p>
        
        <p className="font-sans text-base md:text-lg text-white/80 max-w-3xl mb-10 font-light leading-relaxed">Stay in a quiet residential home featuring 4 individual private rooms,</p>

        <div className="relative group">
          {}
          <div className="absolute -inset-1 bg-[#d9a540] rounded-full blur-xl opacity-30 group-hover:opacity-50 transition duration-500 animate-pulse" />
          
          <Button asChild size="lg" className="relative h-14 px-10 text-lg font-semibold bg-[#d9a540] text-primary-foreground hover:bg-[#c49436] border-none shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 rounded-full">
            <Link to="https://www.airbnb.com/rooms/1516286561442761715">
              Book on Airbnb
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}